<template>
    <div>
        <sys-select-base 
            :model.sync="selected"
            :items="items"
            :loading="loading"
            :label="label"
            :error="error"
            :errors="errors"
            @onShowForm="showForm = true"
            :clearable="clearable"
            :multiple="multiple"
            :hideDetails="hideDetails"
            :class="classe"
            :classe="classe"
            :outlined="outlined"
            :disabled="disabled"
            :dense="dense"
            @change="$emit('change', $event)"
        />
        
    </div>
</template>

<script>

import { mapActions, mapState } from 'vuex'

export default {
    name: 'SysSelectOfferItemStatus',
    data: () => ({
        items: [],
        loading: false,
        selected: null,
        showForm: false
    }),
    computed: {
        ...mapState('auth', ['acesso'])
    },
    mounted(){
        
    },
    created() {
        this.getItems();
    },
    props: {
        
        error: {
            type: Boolean,
            default: false
        },
        errors: {
            type: Array,
        },
        label: {
            type: String,
            required: true
        },
        clearable: {
            type: Boolean,
            default: false
        },
        model: {
        
        },
        multiple: {
            type: Boolean,
            default: false
        },
        includeNull: {
            type: Boolean,
            default: false
        },
        hideDetails: {
            type: [Boolean,String],
            default: false
        },
        classe: {

        },
        outlined: {
            type: Boolean,
            default: false
        },
        nameNull: {
            type: String,
            default: 'Vazio'
        },
        disabled: {
            type: Boolean,
            default: false
        },
        dense: {
            type: Boolean,
            default: false
        },
        statusIds: {
           
        }
        
    },
    watch: {
        
        selected(val){
            this.$emit('update:model', val);
        },
        
        model(val){
            this.selected = val;
        },

        bigOccupationAreaId(val){
            this.getItems();
        }
    },
    methods: {
        ...mapActions('grid', ['ActionIndexOfferItemStatus']),        
        
        async getItems() {

            this.loading = true;
            this.items = [];

            var payload =  {
                find_columns: {
                    active: 1,
                },
                column_order: 'id',
            }

            if(this.statusIds && this.statusIds.length > 0){
                payload.find_columns.id = this.statusIds;
            }

            await this.ActionIndexOfferItemStatus(payload)
                    .then((res) => {
                        
                        if(this.includeNull){
                            this.items.push({
                                id: null,
                                name: this.nameNull
                            });
                        }

                        res.data.forEach(element => {
                            this.items.push(element);
                        });
                        
                        this.selected = this.model;

                    })
                    .finally(() => {
                        this.loading = false;
                    })
        },

        newItem(item){
            
            if(item){
                this.items.push(item);
                this.selected = item.id;
                this.showForm = false;
            }
        }
    },
    
}
</script>